import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function destroyMap(map) {
  if (!map) return;
  try {
    map.stop();
    map.off();
    map.remove();
  } catch {
    /* già rimosso */
  }
}

export default function OriginPickerMap({ lat, lng, onDragEnd }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const draggingRef = useRef(false);
  const onDragEndRef = useRef(onDragEnd);
  const startRef = useRef({ lat, lng });
  onDragEndRef.current = onDragEnd;

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    if (el._leaflet_id != null) {
      el.replaceChildren();
      delete el._leaflet_id;
    }

    const startLat = Number.isFinite(startRef.current.lat) ? startRef.current.lat : 41.9;
    const startLng = Number.isFinite(startRef.current.lng) ? startRef.current.lng : 12.5;

    const map = L.map(el, {
      scrollWheelZoom: true,
      fadeAnimation: false,
      zoomAnimation: false,
    });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    L.DomEvent.disableClickPropagation(el);
    L.DomEvent.disableScrollPropagation(el);
    map.setView([startLat, startLng], 14);

    const marker = L.marker([startLat, startLng], { draggable: true, autoPan: true }).addTo(map);
    marker.bindTooltip("Trascina per spostare il punto di partenza", {
      permanent: false,
      direction: "top",
    });
    marker.on("dragstart", () => {
      draggingRef.current = true;
    });
    marker.on("dragend", () => {
      const pos = marker.getLatLng();
      draggingRef.current = false;
      onDragEndRef.current?.({ lat: pos.lat, lng: pos.lng });
    });
    markerRef.current = marker;

    const t = setTimeout(() => {
      try {
        map.invalidateSize();
        map.setView(marker.getLatLng(), map.getZoom());
      } catch {
        /* ignore */
      }
    }, 250);

    return () => {
      clearTimeout(t);
      destroyMap(mapRef.current);
      mapRef.current = null;
      markerRef.current = null;
      if (el._leaflet_id != null) {
        el.replaceChildren();
        delete el._leaflet_id;
      }
    };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    const marker = markerRef.current;
    if (!map || !marker || !Number.isFinite(lat) || !Number.isFinite(lng)) return;
    if (draggingRef.current) return;
    const cur = marker.getLatLng();
    if (Math.abs(cur.lat - lat) < 1e-6 && Math.abs(cur.lng - lng) < 1e-6) return;
    marker.setLatLng([lat, lng]);
    map.panTo([lat, lng]);
  }, [lat, lng]);

  return (
    <div className="mt-2">
      <div
        ref={containerRef}
        className="w-full h-52 rounded-md border border-white overflow-hidden z-0"
        style={{ minHeight: 208 }}
      />
      <p className="text-[11px] text-slate-500 mt-1">
        Trascina il segnaposto sulla mappa per spostare il punto di partenza: al rilascio si ricalcola il matching.
      </p>
    </div>
  );
}
